import React from "react";

// Compartido entre LicitacionDetail.jsx (/licitaciones/:id, equipo comercial)
// y Delegado.jsx (/delegado). Iter243.
export function KpiBox({ label, value, hint, icon: Icon }) {
  return (
    <div className="bg-gray-50 border border-gray-200 rounded-lg px-3 py-2.5" data-testid={`resumen-kpi-${label.toLowerCase().replace(/\s+/g, "-")}`}>
      <div className="flex items-center gap-1.5 text-[10px] font-semibold text-gray-500 uppercase tracking-wide leading-tight">
        {Icon && <Icon size={11} className="shrink-0" />}<span>{label}</span>
      </div>
      <p className="text-base font-bold font-['Outfit'] text-gray-800 mt-0.5 truncate" title={typeof value === "string" ? value : undefined}>{value ?? "—"}</p>
      {hint && <p className="text-[10px] text-gray-400 mt-0.5 truncate" title={hint}>{hint}</p>}
    </div>
  );
}

export default KpiBox;
